import {Suspense, lazy} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Redirect, Route, Switch} from 'react-router-dom'
import {RootState} from '../../setup'
import {FallbackView} from '../../_metronic/partials'
import UserRole from '../models/UserRole'
import {SSOUserModel} from '../modules/auth/models/UserModel'
import {BerandaChartWrapper} from '../pages/beranda-chart/BerandaChartWrapper'
import {BerandaWrapper} from '../pages/beranda/BerandaWrapper'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {IMenu} from '../modules/auth/models/MenuModel'

export function PrivateRoutes() {
  // const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  // BEGIN - DISABLE FOR PRODUCTION
  // const PenetapanKomponenPage = lazy(() =>
  //   import('../pages/penetapan/PenetapanPage').then((module) => ({
  //     default: module.PenetapanKomponenPage,
  //   }))
  // )
  // const PenetapanRincianOutputPage = lazy(() =>
  //   import('../pages/penetapan/PenetapanPage').then((module) => ({
  //     default: module.PenetapanRincianOutputPage,
  //   }))
  // )
  // const EditKegiatanBulananWrapper = lazy(
  //   () => import('../pages/penetapan/EditKegiatanBulananWrapper')
  // )
  // const PelaporanPage = lazy(() => import('../pages/pelaporan/PelaporanPage'))
  // const DaftarPenetapanROWrapper = lazy(
  //   () => import('../pages/daftar-penetapan-ro/DaftarPenetapanROPage')
  // )
  // const DaftarPenetapanKomponenWrapper = lazy(
  //   () => import('../pages/daftar-penetapan-komponen/DaftarPenetapanKomponenPage')
  // )
  // const DaftarPelaporanROWrapper = lazy(
  //   () => import('../pages/daftar-pelaporan-ro/DaftarPelaporanROPage')
  // )
  // const DaftarPelaporanKomponenWrapper = lazy(
  //   () => import('../pages/daftar-pelaporan-komponen/DaftarPelaporanKomponenPage')
  // )
  // END - DISABLE FOR PRODUCTION

  const DashboardPublikasiku = lazy(
    () => import('../pages/dashboard-publikasiku/DashboardPublikasikuWrapper')
  )
  const DaftarPublikasi = lazy(() => import('../pages/publikasiku/PublikasikuWrapper'))
  const FormPublikasi = lazy(() => import('../pages/publikasiku/FormPublikasiKu'))
  const PublikasiSatker = lazy(
    () => import('../pages/koor-program-satker/publikasi-satker/PublikasiSatker')
  )
  const EditPublikasi = lazy(() => import('../pages/publikasiku/EditPublikasiKu'))
  const Bantuan = lazy(() => import('../pages/bantuan-aplikasi/Bantuan'))

  const UserManagement = lazy(() => import('../pages/user-management/UserManagementWrapper'))
  const PengelolaSatker = lazy(() => import('../pages/pengelola-satker/PengelolaSatker'))

  // BEGIN - DISABLE FOR PRODUCTION
  // const PerKinKepala = lazy(() => import('../pages/perjanjian-kinerja-kepala/PerKinKepalaWrapper'))
  // const RelKinKepala = lazy(() => import('../pages/realisasi-kinerja-kepala/RelKinKepalaWrapper'))
  // const PerKinSatker = lazy(() => import('../pages/perjanjian-kinerja-satker/PerKinSatkerWrapper'))
  // const RelKinSatker = lazy(() => import('../pages/realisasi-kinerja-satker/RelKinSatkerWrapper'))
  // const PercepatanProgramRIN = lazy(
  //   () => import('../pages/percepatan-program-rin/PercepatanProgramRINWrapper')
  // )
  // const KegiatanProgramRIN = lazy(
  //   () => import('../pages/percepatan-program-rin/ProgramKegiatanPage')
  // )
  // const DashboardPercepatanProgramRINWrapper = lazy(
  //   () => import('../pages/dashboard-percepatan-program-rin/DashboardPercepatanProgramRINWrapper')
  // )
  // const DaftarPercepatanProgramRINWrapper = lazy(
  //   () => import('../pages/daftar-percepatan-program-rin/DaftarPercepatanProgramRINWrapper')
  // )
  // const DetailPercepatanProgramRIN = lazy(
  //   () => import('../pages/daftar-percepatan-program-rin/DetailPercepatanProgramRIN')
  // )
  // const FormRencanaKerja = lazy(() => import('../pages/rencana-kerjaku/RencanaKerjakuForm'))
  // const FormUbahRencanaKerja = lazy(() => import('../pages/rencana-kerjaku/RencanaKerjakuFormUbah'))
  // const RencanaKerjaKu = lazy(() => import('../pages/rencana-kerjaku/RencanaKerjakuWrapper'))
  // const FormKegiatan = lazy(() => import('../pages/rencana-kerjaku/FormKegiatan'))
  // const MasterSatuanPK = lazy(() => import('../pages/master-satuan-pk/MasterSatuanPKWrapper'))
  // const CapaianKu = lazy(() => import('../pages/capaian-ku/DaftarProgram'))
  // const StrukturKinerja = lazy(() => import('../pages/struktur-kinerja/StrukturKinerjaWrapper'))
  // END - DISABLE FOR PRODUCTION

  const user: SSOUserModel = useSelector<RootState>(
    ({auth}) => auth.user,
    shallowEqual
  ) as SSOUserModel

  const userMenu: IMenu[] = useSelector<RootState>(({auth}) => auth.menu) as IMenu[]

  const role = user.userrole.data?.role

  const objPengelolaSatker = user.pengelolaSatker

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>

        {/* //BEGIN - DISABLE FOR PRODUCTION */}
        {/* <Route path='/realisasi-kinerja-kepala' component={RelKinKepala} />
        <Route path='/realisasi-kinerja-satker' component={RelKinSatker} /> */}
        {/* //END - DISABLE FOR PRODUCTION */}

        <Route path='/beranda' component={BerandaWrapper} />
        <Route path='/chart-beranda' component={BerandaChartWrapper} />
        <Route path='/dashboard' component={DashboardWrapper} />
        
        {/* //BEGIN - DISABLE FOR PRODUCTION */}
        {/* <Route path='/dashboard-percepatan' component={DashboardPercepatanProgramRINWrapper} />
        <Route path='/arah-risnov' component={RencanaKerjaKu} />
        <Route path='/jejak-risnov' component={CapaianKu} />
        <Route path='/program' component={FormRencanaKerja} />
        <Route path='/ubah-program' component={FormUbahRencanaKerja} />
        <Route path='/kegiatan' component={FormKegiatan} />
        <Route path='/master-satuan-pk' component={MasterSatuanPK} />
        <Route exact path='/percepatan-rin' component={DaftarPercepatanProgramRINWrapper} />
        <Route exact path='/percepatan-rin/detail/:id' component={DetailPercepatanProgramRIN} />
        <Route exact path='/penetapan/komponen' component={PenetapanKomponenPage} />
        <Route exact path='/penetapan/rincian-output' component={PenetapanRincianOutputPage} />
        <Route path='/penetapan/komponen/edit/:bulan' component={EditKegiatanBulananWrapper} />
        <Route path='/pelaporan' component={PelaporanPage} />
        <Route path='/daftar-penetapan-ro' component={DaftarPenetapanROWrapper} />
        <Route path='/daftar-penetapan-komponen' component={DaftarPenetapanKomponenWrapper} />
        <Route path='/daftar-pelaporan-ro' component={DaftarPelaporanROWrapper} />
        <Route path='/daftar-pelaporan-komponen' component={DaftarPelaporanKomponenWrapper} />
        <Route path='/struktur-kinerja' component={StrukturKinerja} />
        <Route exact path={'/percepatan-program-rin'} component={PercepatanProgramRIN} />
        <Route exact path={'/percepatan-program-rin/kegiatan'} component={KegiatanProgramRIN} />
        <Route
          path={'/percepatan-program-rin/kegiatan/edit'}
          component={EditKegiatanBulananWrapper}
        /> */}
        {/* //END - DISABLE FOR PRODUCTION */}

        <Route path={'/dashboard-publikasiku'} component={DashboardPublikasiku} />
        <Route path={'/publikasiku'} component={DaftarPublikasi} />
        <Route path={'/publikasi'} exact component={FormPublikasi} />
        <Route path={'/publikasi/edit/:publikasiId'} component={EditPublikasi} />

        <Route path={'/publikasi-satker'}>
          {role === undefined ? null : role.length > 0 ? ( // do not render if undefined // check if role array has element
            role.find(
              (element) =>
                element.id.toString() ===
                (UserRole.VerifikatorErenMonev.toString() ||
                  UserRole.SuperAdminErenmonev.toString())
            ) ? ( // find role id 477 (Verifikator ErenMonev)
              <Route path={'/publikasi-satker'} component={PublikasiSatker} />
            ) : null
          ) : null}
        </Route>

        <Route path={'/peran-pengguna'}>
          {role === undefined ? null : role.length > 0 ? ( // do not render if undefined // check if role array has element
            role.find(
              (element) =>
                element.id.toString() ===
                (UserRole.PengelolaPusatErenmonev.toString() ||
                  UserRole.SuperAdminErenmonev.toString())
            ) ? ( // find role id 477 (Verifikator ErenMonev)
              <Route path={'/peran-pengguna'} component={UserManagement} />
            ) : null
          ) : null}
        </Route>

        <Route path={'/pengelola-satker'}>
          {(role === undefined
            ? null
            : role.find((el) => el.id.toString() === UserRole.SuperAdminErenmonev.toString())) ||
          objPengelolaSatker.role.length > 0 ? (
            <Route path={'/pengelola-satker'} component={PengelolaSatker} />
          ) : null}
        </Route>

        {/* //BEGIN - DISABLE FOR PRODUCTION */}
        {/* <Route path={'/perkin-kepala'}>
          {(role === undefined
            ? null
            : role.find((el) => el.id.toString() === UserRole.SuperAdminErenmonev.toString())) ||
          objPengelolaSatker.role.length > 0 ? (
            <>
              <Route path={'/perkin-kepala'} component={PerKinKepala} />
            </>
          ) : null}
        </Route>

        <Route path={'/perkin-satker'}>
          {(role === undefined
            ? null
            : role.find((el) => el.id.toString() === UserRole.SuperAdminErenmonev.toString())) ||
          objPengelolaSatker.role.length > 0 ? (
            <>
              <Route path={'/perkin-satker'} component={PerKinSatker} />
            </>
          ) : null}
        </Route> */}
        {/* //END - DISABLE FOR PRODUCTION */}

        {/* <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} /> */}
        {/* <Route path='/menu-test' component={MenuTestPage} /> */}
        <Route path={'/bantuan'} component={Bantuan} />
        <Redirect from='/auth/login' to='/publikasiku' />
        <Redirect exact from='/' to='/publikasiku' />
        <Redirect to='/error/404' />
      </Switch>
    </Suspense>
  )
}
